import { url } from "./url_config";

export async function sendCommand(hwid, id, command, token) {
    try {
        const response = await fetch(`${url}devices/command/${hwid}?id=${id}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({ command : command })
        });

        const data = await response.json();
        await new Promise(resolve => setTimeout(resolve, 750));

        if (!response.ok) {
            if (response.status === 400) {
                throw new Error("Comando inválido");
            } else {
                throw new Error(data.message || "Error de red");
            }
        }

        return data;

    } catch (e) {
        console.error("send command error:", e);
        throw e;
    }
}